module.exports = __webpack_public_path__ + "img/2.df999de9.png";